import React from 'react';
import { LucideIcon } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { FriendlyIllustration, type FriendlyIllustrationKind } from '@/components/ui/FriendlyIllustration';
import { cn } from '@/lib/utils';

interface EmptyStateProps {
  // ReactElement<P> takes the element's PROPS type, not the component type.
  icon: React.ReactElement<{ className?: string }>;
  title: string;
  description?: string;
  action?: React.ReactNode;
  variant?: 'default' | 'dashed';
  className?: string;
  illustration?: FriendlyIllustrationKind;
}

export function EmptyState({
  icon,
  title,
  description,
  action,
  variant = 'dashed',
  className,
  illustration,
}: EmptyStateProps) {
  return (
    <Card
      className={cn(
        'shadow-sm',
        variant === 'dashed' ? 'border-2 border-dashed border-slate-200 bg-slate-50' : 'border-slate-200',
        className
      )}
    >
      <CardContent className="py-16 text-center">
        {illustration
          ? <FriendlyIllustration kind={illustration} className="mx-auto mb-2 h-32 w-auto max-w-[220px] drop-shadow-[0_12px_20px_rgba(14,116,190,0.12)]" />
          : React.cloneElement(icon, { className: 'h-12 w-12 text-slate-300 mx-auto mb-4' })}
        <p className="text-slate-500 font-medium">{title}</p>
        {description && <p className="text-sm text-slate-400 mt-1">{description}</p>}
        {action && <div className="mt-6">{action}</div>}
      </CardContent>
    </Card>
  );
}
